import { UsernameEmail } from 'src/components/manage-otps/list/table/columns/username-email';
import { DataTableMeta, DateColumn } from '@otp/ui';
import { StoreModel, User, UserLevel } from 'src/graphql/generated/graphql';
import { UserLevelColumn } from 'src/components/common/table/columns/level';
import { TFunction } from 'i18next';
import { Star } from '@otp/icons';
import { OTPsAssignedListActions } from './otps-assigned-list-actions';
import { getUserLevels } from 'src/utils/user-data';
import React from 'react';

type DataParams = {
  store: Partial<StoreModel>;
  users: Array<Partial<User> & { isPrimary: boolean }>;
};

export const getAssignedOTPsTableConfig = (
  { store, users }: DataParams,
  { t }: { t: TFunction },
) => [
  {
    name: 'lastName',
    label: t('manage-restaurants.otps.user-details'),
    options: {
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = users[column.rowIndex];
        return <UsernameEmail user={rowData} options={{ nameOnly: false }} />;
      },
    },
  },
  {
    name: 'isPrimary',
    label: t('manage-restaurants.otps.assigned-as'),
    options: {
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = users[column.rowIndex];
        return rowData.isPrimary ? (
          <div className="flex gap-1">
            <Star />
            Primary
          </div>
        ) : (
          'Secondary'
        );
      },
    },
  },
  {
    name: 'mcId',
    label: t('manage-restaurants.otps.eid'),
  },
  {
    name: 'level',
    label: t('manage-restaurants.otps.level'),
    options: {
      customBodyRender: (_: UserLevel, column: DataTableMeta) => {
        const user = users[column.rowIndex];
        const userLevels = getUserLevels(user);

        return userLevels.map((level) => (
          <UserLevelColumn key={`${user}-${level}`} level={level} />
        ));
      },
    },
  },
  {
    name: 'storesCount',
    label: t('manage-restaurants.otps.stores'),
  },
  {
    name: 'updatedAt',
    label: t('manage-restaurants.otps.last-time-active'),
    options: {
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = users[column.rowIndex];
        return <DateColumn date={rowData.updatedAt} />;
      },
    },
  },
  {
    name: 'actions',
    label: t('manage-restaurants.otps.actions'),
    options: {
      customBodyRender: (value: any, column: DataTableMeta) => {
        const user = users[column.rowIndex];
        const storeHasPrimary = users.some((u) => u.isPrimary);

        return (
          <OTPsAssignedListActions
            store={store}
            user={user}
            storeHasPrimary={storeHasPrimary}
          />
        );
      },
    },
  },
];
